import { RadioGroup } from 'bricks-ui/packages/bricks-ui';

export default RadioGroup;
